module.exports = __webpack_public_path__ + "img/redtube.7ccce8c.png";